import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logoDecode from '../../assets/LogoDecode.jpeg';
import './Header.css';

export const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header className={`hdr ${scrolled ? 'hdr--scrolled' : ''}`}>
      <div className="hdr__inner">
        <Link to="/" className="hdr__logo">
          <img src={logoDecode} alt="Decode Byte" />
          <span>Decode<strong>Byte</strong></span>
        </Link>

        <nav className={`hdr__nav ${mobileOpen ? 'hdr__nav--open' : ''}`}>
          <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
            Home
          </Link>
          <Link to="/sobre" className={location.pathname === '/sobre' ? 'active' : ''}>
            Sobre
          </Link>
          <a href="/#tarefas-perto">Tarefas Perto</a>
          <Link to="/contato" className={location.pathname === '/contato' ? 'active' : ''}>
            Contato
          </Link>
          <Link to="/tarefas-perto" className="hdr__cta">
            Ver App
          </Link>
        </nav>

        <button
          className={`hdr__hamburger ${mobileOpen ? 'hdr__hamburger--open' : ''}`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};
